module.exports = __webpack_public_path__ + "static/worker-saftey-builtin-19cf20198d83f71d0398b4d16c341b5f.png";